var _path, _path2, _path3, _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgMapPin = function SvgMapPin(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_752_4418",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10758 13.6498C2.59925 14.1023 1.66675 14.7273 1.66675 15.4177C1.66675 16.7985 5.39758 17.9177 10.0001 17.9177C14.6026 17.9177 18.3334 16.7985 18.3334 15.4177C18.3334 14.7273 17.4005 14.1023 15.8926 13.6498",
    stroke: "white",
    strokeWidth: 1.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 14.5844C10.0002 14.5844 15.4168 11.0444 15.4168 6.95189C15.4168 4.03356 12.9918 1.66772 10.0002 1.66772C7.0085 1.66772 4.5835 4.03356 4.5835 6.95189C4.5835 11.0444 10.0002 14.5844 10.0002 14.5844Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.58333,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 9.16777C10.5526 9.16777 11.0825 8.94827 11.4732 8.55757C11.8639 8.16687 12.0834 7.63697 12.0834 7.08443C12.0834 6.5319 11.8639 6.00199 11.4732 5.61129C11.0825 5.22059 10.5526 5.0011 10.0001 5.0011C9.44755 5.0011 8.91764 5.22059 8.52694 5.61129C8.13624 6.00199 7.91675 6.5319 7.91675 7.08443C7.91675 7.63697 8.13624 8.16687 8.52694 8.55757C8.91764 8.94827 9.44755 9.16777 10.0001 9.16777Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.58333,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_752_4418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000366211H20V20.0004H0V0.000366211Z",
    fill: "white"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map-pin.c795b57d.svg";
export { ForwardRef as ReactComponent };